export default "__VITE_ASSET__1022f18d__"